import spCommentSettlementDialogTemplate from './spCommentSettlementDialog.html';
import spCommentSettlementTemplate from './spCommentSettlementForm.html';

angular
   .module('org.saga.spcommentsettlement', [
      'org.saga.spprioritycomment',
      'org.saga.newsppriority',
      'org.saga.newspactivity',
      'org.saga.newspbudgetitem',
      'isolateForm'
   ])
   .directive('spCommentSettlement', [
      function () {
         return {
            restrict: 'E',
            template: spCommentSettlementTemplate,
            scope: {
               comment: '=',
               newCommentForm: '='
            },
            controller: [
               '$scope',
               function ($scope) {
                  $scope.commentSeverity = [
                     { value: 'RECOMMENDED', label: 'Doporučená' },
                     { value: 'FORMAL', label: 'Formální' },
                     { value: 'MAJOR', label: 'Zásadní' }
                  ];
               }
            ]
         };
      }
   ])

   .factory('SpCommentSettlementDialog', [
      '$mdDialog',
      '$log',
      function ($mdDialog) {
         return {
            show: function (priority, activity, budgetItem, comment, configuration, callback) {
               function DialogController($scope, $log, $mdDialog) {
                  $scope.priority = priority;
                  $scope.activity = activity;
                  $scope.budgetItem = budgetItem;
                  $scope.comment = comment;
                  $scope.configuration = configuration;

                  $scope.cancel = function () {
                     $mdDialog.cancel();
                  };

                  $scope.ok = function () {
                     $mdDialog.hide({
                        comment: $scope.comment,
                        priority: $scope.priority,
                        activity: $scope.activity,
                        budgetItem: $scope.budgetItem
                     });
                  };
               }

               $mdDialog
                  .show({
                     controller: ['$scope', '$log', '$mdDialog', DialogController],
                     template: spCommentSettlementDialogTemplate,
                     parent: angular.element(document.body),
                     clickOutsideToClose: false
                  })
                  .then(
                     function (answer) {
                        callback(answer);
                     },
                     function () {
                        // callback is not called
                     }
                  );
            }
         };
      }
   ]);
